import { useMutation } from '@tanstack/react-query';
import { postData } from '../utils/api';
import { useSnackbar } from 'notistack';
import useLocalization from '../hooks/useLocalization';
import { tError } from '../helpers/translation';
import { AxiosError } from 'axios';

export type FormValues = {
  walletType: string;
  userId: string;
  amount: number;
  isForAgentPayment: boolean;
  transactionType: string;
  otherTransactionType: string;
  source: string;
};

export const useUpdateBalance = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useLocalization();

  return useMutation({
    mutationFn: (data: FormValues) => postData('payment/credits', data, 'wallet'),
    onSuccess: () => {
      enqueueSnackbar(t('responseMessages.balanceUpdated'), {
        variant: 'success',
      });
    },
    onError: (error: unknown) => {
      if (error instanceof AxiosError) {
        const errorCode = error.response?.data?.code;
        const message = errorCode ? tError(errorCode) : t('responseMessages.unexpectedErrorOccurred');

        enqueueSnackbar(message, {
          variant: 'error',
        });
      }
    },
  });
};
